interface IClusterInitialState {
  filters: { [key: string]: string };
}
export const clusterState: IClusterInitialState = {
  filters: {},
};
